import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { InventoryKindQuery, InventoryKindQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryKindQuery)
@Wrapper(InventoryKindQueryHandlerBase)
export class InventoryKindQueryHandler {
    public constructor(
        http: Http
    ) { }
}
